import moment from "moment";
import { useCallback, useRef, useState } from "react";

import { useReactToPrint } from "react-to-print";
import { Spinner } from "reactstrap";

export const ButtonPrintSPD = ({ innerRef, title }) => {
  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const reactToPrintContent = useCallback(() => {
    return innerRef.current;
  }, [innerRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: title,
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  return (
    <button
      type="submit"
      className="btn btn-item"
      onClick={() => {
        handlePrint();
      }}
    >
      CETAK &nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
    </button>
  );
};

export const PrintDocSPD = ({ innerRef, item, type, companyName, companyValue }) => {
  const handleValidDate = (date) => {
    return moment(date).format("MMM D, YYYY");
  };

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  switch (type) {
    case "spd_bangunan":
      return !item || item === undefined || item === null ? (
        <></>
      ) : (
        <div
          className="d-none"
          style={{
            overflow: "scroll",
            //backgroundColor: "blue"
          }}
        >
          <div ref={innerRef} className="bg-white" style={{ padding: "40px 40px 40px 40px" }}>
            <div style={{ padding: "0px" }}>
              <div>Lampiran : Surat Pernyataan Debitur</div>
              <div
                style={{
                  textAlign: "center",
                  textDecoration: "underline",
                  fontSize: "18px",
                  fontWeight: "bold",
                }}
              >
                SURAT PERNYATAAN
              </div>
              <div style={{ padding: "20px" }}>
                <table style={{ borderCollapse: "collapse", tableLayout: "fixed" }}>
                  <tbody>
                    <tr>
                      <td colSpan={3}>Yang bertanda tangan di bawah ini :</td>
                    </tr>
                    <tr>
                      <td style={{ verticalAlign: "top", width: "150px" }}>Nama</td>
                      <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                      <td>{item.sls_appl?.name ?? ""}</td>
                    </tr>
                    <tr>
                      <td style={{ verticalAlign: "top", width: "150px" }}>Tempat/Tanggal Lahir</td>
                      <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                      <td>
                        {item.sls_appl?.birth_place ?? ""} , {handleValidDate(item.sls_appl?.birthat) ?? ""}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ verticalAlign: "top", width: "150px" }}>NIK</td>
                      <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                      <td>{item.sls_appl?.identity ?? ""}</td>
                    </tr>
                    <tr>
                      <td style={{ verticalAlign: "top", width: "150px" }}>Pekerjaan</td>
                      <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                      <td>{item.sls_appl?.job_desc ?? ""}</td>
                    </tr>
                    <tr>
                      <td style={{ verticalAlign: "top", width: "150px" }}>Alamat KTP</td>
                      <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                      <td>{item.sls_appl?.address ?? ""}</td>
                    </tr>
                  </tbody>
                </table>

                <p style={{ margin: "10px 0px" }}>Selanjutnya disebut sebagai Debitur</p>

                <table style={{ borderCollapse: "collapse", tableLayout: "fixed" }}>
                  <tbody>
                    <tr>
                      <td colSpan={3}>Sehubungan dengan pembelian rumah yang saya lakukan di :</td>
                    </tr>
                    <tr>
                      <td style={{ verticalAlign: "top", width: "150px" }}>Perumahan</td>
                      <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                      <td>{item.sales_branch?.name ?? ""}</td>
                    </tr>
                    <tr>
                      <td style={{ verticalAlign: "top", width: "150px" }}>Blok/Type</td>
                      <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                      <td>{item.sales_detail[0]?.name ?? ""}</td>
                    </tr>
                    <tr>
                      <td style={{ verticalAlign: "top", width: "150px" }}>Lokasi</td>
                      <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                      <td>{item.sales_branch?.branch_address[0]?.description}</td>
                    </tr>
                    <tr>
                      <td style={{ verticalAlign: "top", width: "150px" }}>Pengembang</td>
                      <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                      <td>{item.sales_company?.name ?? ""}</td>
                    </tr>
                  </tbody>
                </table>

                <p style={{ margin: "10px 0px" }}>Dengan ini Debitur menyatakan hal-hal sebagai berikut</p>

                <p style={{ margin: "20px 0px", fontWeight: "bold", fontSize: "16px", borderBottom: "1px solid #555" }}>
                  A. PERNYATAAN KONDISI BANGUNAN – PSU DAN KONDISI LEGALITAS SAAT AKAD KREDIT
                </p>

                <p style={{ margin: "20px 0px" }}>
                  Saya telah mengetahui, memahami, dan menerima kondisi bangunan, prasarana, sarana,
                  utilitas umum (PSU) serta legalitas/bukti kepemilikan atas unit rumah yang dibeli.
                  Saya mengetahui dan menerima bahwa kondisi berikut :
                </p>

                <table style={{ borderCollapse: "collapse", tableLayout: "fixed" }}>
                  <tbody>
                    <tr>
                      <td style={{ width: "50%", textAlign: "center", fontWeight: "bold", margin: "10px 0px", fontSize: "14px" }}>Kondisi Bangunan dan PSU Dalam Penyelesaian</td>
                      <td style={{ width: "50%", textAlign: "center", fontWeight: "bold", margin: "10px 0px", fontSize: "14px" }}>Legalitas</td>
                    </tr>
                    <tr>
                      <td style={{ width: "50%" }}>
                        <div style={{ margin: "5px 0px", display: "flex" }}><em style={{ flex: "0 0 20px", textAlign: "center", width: "20px", height: "20px", display: "inline-block", marginRight: "5px", marginBottom: "5px", border: "1px solid #000" }}><i className="ri-check-line fs-14"></i></em>KWH Listrik</div>
                        <div style={{ margin: "5px 0px", display: "flex" }}><em style={{ flex: "0 0 20px", textAlign: "center", width: "20px", height: "20px", display: "inline-block", marginRight: "5px", marginBottom: "5px", border: "1px solid #000" }}><i className="ri-check-line fs-14"></i></em>Bangunan Rumah</div>
                        <div style={{ margin: "5px 0px", display: "flex" }}><em style={{ flex: "0 0 20px", textAlign: "center", width: "20px", height: "20px", display: "inline-block", marginRight: "5px", marginBottom: "5px", border: "1px solid #000" }}><i className="ri-check-line fs-14"></i></em>Sumber Air Bersih</div>
                        <div style={{ margin: "5px 0px", display: "flex" }}><em style={{ flex: "0 0 20px", textAlign: "center", width: "20px", height: "20px", display: "inline-block", marginRight: "5px", marginBottom: "5px", border: "1px solid #000" }}><i className="ri-check-line fs-14"></i></em>Jalan Lingkungan</div>
                        <div style={{ margin: "5px 0px", display: "flex" }}><em style={{ flex: "0 0 20px", textAlign: "center", width: "20px", height: "20px", display: "inline-block", marginRight: "5px", marginBottom: "5px", border: "1px solid #000" }}><i className="ri-check-line fs-14"></i></em>Saluran Drainase</div>
                      </td>
                      <td style={{ width: "50%" }}>
                        <div style={{ margin: "5px 0px", display: "flex" }}><em style={{ flex: "0 0 20px", textAlign: "center", width: "20px", height: "20px", display: "inline-block", marginRight: "5px", marginBottom: "5px", border: "1px solid #000" }}><i className="ri-check-line fs-14"></i></em>Sertipikat berupa Peta Bidang Tanah/SKHGB/Sertipikat Induk/Sertipikat Pecahan</div>
                        <div style={{ margin: "5px 0px", display: "flex" }}><em style={{ flex: "0 0 20px", textAlign: "center", width: "20px", height: "20px", display: "inline-block", marginRight: "5px", marginBottom: "5px", border: "1px solid #000" }}><i className="ri-check-line fs-14"></i></em>Izin Mendirikan Bangunan (IMB) dalam Proses</div>
                        <div style={{ margin: "5px 0px", display: "flex" }}><em style={{ flex: "0 0 20px", textAlign: "center", width: "20px", height: "20px", display: "inline-block", marginRight: "5px", marginBottom: "5px", border: "1px solid #000" }}><i className="ri-check-line fs-14"></i></em>Persetujuan Bangunan Gedung (PBG) dalam proses</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p style={{ margin: "20px 0px" }}>*: dicoret yang tidak perlu.</p>
                <div style={{ margin: "5px 0px", display: "flex" }}><em style={{ flex: "0 0 20px", textAlign: "center", width: "20px", height: "20px", display: "inline-block", marginRight: "5px", marginBottom: "5px", border: "1px solid #000" }}><i className="ri-check-line fs-14"></i></em>
                  Saya mengerti dan menerima bahwa penyelesaian kewajiban bangunan – PSU dan legalitas rumah
                  adalah tanggung jawab dari penjual/pengembang.</div>
                <div style={{ margin: "5px 0px", display: "flex" }}><em style={{ flex: "0 0 20px", textAlign: "center", width: "20px", height: "20px", display: "inline-block", marginRight: "5px", marginBottom: "5px", border: "1px solid #000" }}><i className="ri-check-line fs-14"></i></em>
                  Debitur menyatakan telah memperoleh penjelasan yang memadai mengenal kondisi bangunan, PSU
                  dan legalitas rumah sebelum penandatanganan akad kredit.</div>

                <p style={{ margin: "20px 0px", fontWeight: "bold", fontSize: "16px", borderBottom: "1px solid #555" }}>
                  B. PERNYATAAN AKAD KREDIT KONDISI PERSETUJUAN BANGUNAN GEDUNG (PBG)
                </p>
                <div style={{ margin: "5px 0px", }}><em style={{ flex: "0 0 20px", textAlign: "center", width: "20px", height: "20px", display: "inline-block", marginRight: "5px", marginBottom: "5px", border: "1px solid #000" }}><i className="ri-check-line fs-14"></i></em>Debitur mengetahui dan menerima bahwa kondisi dokumen saat akad kredit adalah berupa
                  <b>Izin Mendirikan Bangunan (IMB) / Persetujuan Bangunan Gedung (PBG)*</b></div>


                <div style={{ breakAfter: "page" }}></div>
                <div style={{ marginTop: "40px" }}></div>

                <div style={{ margin: "5px 0px", display: "flex" }}><em style={{ flex: "0 0 20px", textAlign: "center", width: "20px", height: "20px", display: "inline-block", marginRight: "5px", marginBottom: "5px", border: "1px solid #000" }}><i className="ri-check-line fs-14"></i></em>Debitur mengetahui bahwa dokumen yang diterima Bank dari pihak Pengembang pada saat akad
                  Adalah dokumen Izin Mendirikan Bangunan (IMB) / Persetujuan Bangunan Gedung (PBG) sedang Dalam proses.</div>

                <div style={{ margin: "5px 0px", display: "flex" }}><em style={{ flex: "0 0 20px", textAlign: "center", width: "20px", height: "20px", display: "inline-block", marginRight: "5px", marginBottom: "5px", border: "1px solid #000" }}><i className="ri-check-line fs-14"></i></em>Debitur mengetahui bahwa dokumen bukti kepemilikan bangunan Gedung adalah Sertipikat Bukti
                  Kepemilikan Bangunan Gedung (SKHGB).</div>
                <div style={{ margin: "5px 0px", display: "flex" }}><em style={{ flex: "0 0 20px", textAlign: "center", width: "20px", height: "20px", display: "inline-block", marginRight: "5px", marginBottom: "5px", border: "1px solid #000" }}><i className="ri-check-line fs-14"></i></em> Dalam hal Pemerintah Kabupaten/Kota setempat memberlakukan ketentuan penerbitan Persetujuan
                  Bangunan Gedung (PBG), Sertipikat Laik Fungsi (SLF) dan Surat Bukti Kepemilikan Bangunan Gedung
                  (SKHBG), atau dikemudian hari terdapat perubahan ketentuan pemerintah maka pengurusan
                  Dokumen tersebut merupakan tanggung jawab dari pengembang.</div>
                <div style={{ margin: "5px 0px", display: "flex" }}><em style={{ flex: "0 0 20px", textAlign: "center", width: "20px", height: "20px", display: "inline-block", marginRight: "5px", marginBottom: "5px", border: "1px solid #000" }}><i className="ri-check-line fs-14"></i></em>Debitur memahami bahwa Bank bertindak sebagai pemberi fasilitas kredit dan tidak bertanggung
                  Jawab atas penerbitan, penyelesaian, maupun keterlambatan dokumen perizinan yang menjadi
                  Kewajiban pengembang.</div>

                <p style={{ margin: "20px 0px", fontWeight: "bold", fontSize: "16px", borderBottom: "1px solid #555" }}>
                  C. PERNYATAAN AGUNAN DAN PENGALIHAN HAK
                </p>
                <div style={{ margin: "5px 0px", display: "flex" }}><em style={{ flex: "0 0 20px", textAlign: "center", width: "20px", height: "20px", display: "inline-block", marginRight: "5px", marginBottom: "5px", border: "1px solid #000" }}><i className="ri-check-line fs-14"></i></em>Debitur menyatakan bahwa hak atas tanah dan/atau bangunan yang telah dilakukan balik nama ke atas
                  Nama debitur tetap menjadi jaminan/agunan KPR Bersubsidi BTN sampai seluruh kewajiban kredit
                  Dinyatakan lunas.</div>
                <div style={{ margin: "5px 0px", display: "flex" }}><em style={{ flex: "0 0 20px", textAlign: "center", width: "20px", height: "20px", display: "inline-block", marginRight: "5px", marginBottom: "5px", border: "1px solid #000" }}><i className="ri-check-line fs-14"></i></em>Selama masa kredit belum lunas, debitur bersedia dan setuju untuk tidak mengalihkan, menjual,
                  Menyewakan maupun memindahtangankan unit rumah kepada pihak lain tanpa persetujuan Bank BTN
                  Dan sesuai ketentuan perundang-undangan yang berlaku.</div>
                <p style={{ margin: "20px 0px", fontWeight: "bold", fontSize: "16px", borderBottom: "1px solid #555" }}>
                  D. LAIN-LAIN
                </p>
                <div style={{ margin: "5px 0px", display: "flex" }}><em style={{ flex: "0 0 20px", textAlign: "center", width: "20px", height: "20px", display: "inline-block", marginRight: "5px", marginBottom: "5px", border: "1px solid #000" }}><i className="ri-check-line fs-14"></i></em>Debitur mengerti bahwa BTN tidak memberikan penjaminan atas pemenuhan tanggung jawab
                  Pengembang.</div>
                <div style={{ margin: "5px 0px", display: "flex" }}><em style={{ flex: "0 0 20px", textAlign: "center", width: "20px", height: "20px", display: "inline-block", marginRight: "5px", marginBottom: "5px", border: "1px solid #000" }}><i className="ri-check-line fs-14"></i></em>Debitur menyatakan bahwa permasalahan dengan pengembang sehubungan dengan seluruh
                  Kondisi tersebut diatas tidak menghapus, menunda, atau mengurangi kewajiban pembayaran
                  Kepada Bank sesuai dengan perjanjian kredit.</div>
                <div style={{ margin: "5px 0px", display: "flex" }}><em style={{ flex: "0 0 20px", textAlign: "center", width: "20px", height: "20px", display: "inline-block", marginRight: "5px", marginBottom: "5px", border: "1px solid #000" }}><i className="ri-check-line fs-14"></i></em>Debitur memahami bahwa surat pernyataan ini merupakan satu kesatuan yang tidak terpisahkan
                  Dari perjanjian kredit dan seluruh dokumen fasilitas kredit yang ditandatangin oleh debitur
                  Dengan BTN.</div>
                <div style={{ margin: "5px 0px", display: "flex" }}><em style={{ flex: "0 0 20px", textAlign: "center", width: "20px", height: "20px", display: "inline-block", marginRight: "5px", marginBottom: "5px", border: "1px solid #000" }}><i className="ri-check-line fs-14"></i></em>Sepanjang BTN telah memenuhi kewajiban sesuai dengan perjanjian kredit, debitur melepaskan
                  BTN dari segala bentuk tuntutan hukum dikemudian hari yang timbul atas permasalahan dengan
                  Pengembang sehubungan dengan seluruh kondisi tersebut diatas.</div>


                <div
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    alignItems: "start",
                    gap: "10px",
                  }}
                >
                  <div
                    style={{
                      marginTop: "25px",
                      width: "250px",
                      textAlign: "center",
                    }}
                  >
                    <div>Bogor, ............................</div>
                    <div
                      style={{
                        marginTop: "100px",
                      }}
                    >{`${item.sales_customer?.name ?? ""}`}</div>
                  </div>
                </div>

                <div style={{ margin: "20px 0px", fontWeight: "bold" }}>Catatan:
                  <ol>
                    <li>Mohon centang pada kotak ceklis yang disediakan (      )</li>
                    <li>Pernyataan yang dipilih wajib sesuai kondisi kebijakan yang diperlukan</li>
                    <li>Dapat memilih dari 1 (satu) Checklist disesuaikan dengan kebijakan yang diperlukan</li>
                  </ol>
                </div>
              </div>

              <div style={{ breakAfter: "page" }}></div>
              <div
                style={{
                  textAlign: "center",
                  textDecoration: "underline",
                  fontSize: "18px",
                  fontWeight: "bold",
                }}
              >
                SURAT KUASA
              </div>
              <div style={{ padding: "20px" }} className="page">
                <table style={{ borderCollapse: "collapse", tableLayout: "fixed" }}>
                  <tbody>
                    <tr>
                      <td colSpan={3}>Yang bertanda tangan di bawah ini :</td>
                    </tr>
                    <tr>
                      <td style={{ verticalAlign: "top", width: "150px" }}>Nama</td>
                      <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                      <td>{item?.sls_appl?.name ?? ""}</td>
                    </tr>
                    <tr>
                      <td style={{ verticalAlign: "top", width: "150px" }}>No. KTP</td>
                      <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                      <td>{item?.sls_appl?.identity ?? ""}</td>
                    </tr>
                    <tr>
                      <td style={{ verticalAlign: "top", width: "150px" }}>Tempat/Tanggal Lahir</td>
                      <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                      <td>
                        {item?.sls_appl?.birth_place ?? ""} , {handleValidDate(item?.sls_appl?.birthat) ?? ""}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ verticalAlign: "top", width: "150px" }}>Pekerjaan</td>
                      <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                      <td>{item?.sls_appl?.job_position ?? ""}</td>
                    </tr>
                    <tr>
                      <td style={{ verticalAlign: "top", width: "150px" }}>No. Telepon/HP</td>
                      <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                      <td>{item?.sls_appl?.phone ?? ""}</td>
                    </tr>
                    <tr>
                      <td style={{ verticalAlign: "top", width: "150px" }}>Alamat</td>
                      <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                      <td>{item?.sls_appl?.address ?? ""}</td>
                    </tr>
                  </tbody>
                </table>

                <p style={{ marginTop: "40px" }}>yang dalam hal ini bertindak untuk dan atas nama sendiri. Selanjutnya disebut “Pemberi Kuasa”. YAYAN SUTIATI,S.H.,M.Kn dalam hal ini bertindak dalam jabatan Notaris di Kabupaten Bogor yang Selanjutnya disebut “Penerima Kuasa”.</p>
                <p style={{ textAlign: "center" }}>KHUSUS</p>
                <p>dengan ini Pemberi Kuasa memberikan kuasa kepada Penerima Kuasa untuk dapat melakukan Pengambilan Sertifikat Elektronik atas nama Pemberi Kuasa di Kantor Pertanahan Kabupaten Bogor II</p>
                <p>yang selanjutnya Sertifikat tersebut akan diserahkan kepada PT Bank Tabungan Negara (Persero) Tbk atas dasar Perjanjian Kredit KPR Bersubsidi No&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;tanggal&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2024</p>
                <p>Demikian Surat Kuasa ini dibuat dengan Hak Substitusi, dan tidak dapat dicabut kembali serta tidak akan berakhir karena sebab – sebab yang tercantum dalam Pasal 1813 Kitab Undang – Undang Hukum Perdata atau karena sebab apapun juga.</p>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "start",
                    gap: "10px",
                  }}
                >
                  <div
                    style={{
                      marginTop: "25px",
                      width: "250px",
                      textAlign: "center",
                    }}
                  >
                    <div style={{ textAlign: "center" }}>PENERIMA KUASA</div>
                    <div
                      style={{
                        marginTop: "120px",
                      }}
                    >
                      (....................................................)
                    </div>
                    <div>Nama lengkap, Jabatan</div>
                    <div>*) coret yang tidak perlu</div>
                  </div>

                  <div
                    style={{
                      marginTop: "25px",
                      width: "250px",
                      textAlign: "center",
                    }}
                  >
                    <div>Bogor, {handleValidDate()}</div>
                    <div style={{ textAlign: "center" }}>PEMBERI KUASA</div>
                    <div
                      style={{
                        marginTop: "100px",
                      }}
                    >{`(${item.sls_appl?.name ?? ""})`}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div >
      );

    case "spd_elektronik":
      return !item || item === undefined || item === null ? (
        <></>
      ) : (
        <div
          className="d-none"
          style={{
            overflow: "scroll",
            //backgroundColor: "blue"
          }}
        >
          <div ref={innerRef} className="bg-white" style={{ padding: "40px 40px 40px 40px" }}>
            <div style={{ padding: "0px" }}>
              <div>Lampiran : Surat Pernyataan Debitur</div>
              <div
                style={{
                  textAlign: "center",
                  textDecoration: "underline",
                  fontSize: "18px",
                  fontWeight: "bold",
                }}
              >
                SURAT PERNYATAAN
              </div>
              <div style={{ padding: "20px" }}>
                <table style={{ borderCollapse: "collapse", tableLayout: "fixed" }}>
                  <tbody>
                    <tr>
                      <td colSpan={3}>Yang bertanda tangan di bawah ini :</td>
                    </tr>
                    <tr>
                      <td style={{ verticalAlign: "top", width: "150px" }}>Nama</td>
                      <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                      <td>{item.sls_appl?.name ?? ""}</td>
                    </tr>
                    <tr>
                      <td style={{ verticalAlign: "top", width: "150px" }}>Tempat/Tanggal Lahir</td>
                      <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                      <td>
                        {item.sls_appl?.birth_place ?? ""} , {handleValidDate(item.sls_appl?.birthat) ?? ""}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ verticalAlign: "top", width: "150px" }}>NIK</td>
                      <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                      <td>{item.sls_appl?.identity ?? ""}</td>
                    </tr>
                    <tr>
                      <td style={{ verticalAlign: "top", width: "150px" }}>Pekerjaan</td>
                      <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                      <td>{item.sls_appl?.job_desc ?? ""}</td>
                    </tr>
                    <tr>
                      <td style={{ verticalAlign: "top", width: "150px" }}>Alamat KTP</td>
                      <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                      <td>{item.sls_appl?.address ?? ""}</td>
                    </tr>
                  </tbody>
                </table>

                <p style={{ margin: "10px 0px" }}>Selanjutnya disebut sebagai Debitur</p>

                <table style={{ borderCollapse: "collapse", tableLayout: "fixed" }}>
                  <tbody>
                    <tr>
                      <td colSpan={3}>Sehubungan dengan pembelian rumah yang saya lakukan di :</td>
                    </tr>
                    <tr>
                      <td style={{ verticalAlign: "top", width: "150px" }}>Perumahan</td>
                      <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                      <td>{item.sales_branch?.name ?? ""}</td>
                    </tr>
                    <tr>
                      <td style={{ verticalAlign: "top", width: "150px" }}>Blok/Type</td>
                      <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                      <td>{item.sales_detail[0]?.name ?? ""}</td>
                    </tr>
                    <tr>
                      <td style={{ verticalAlign: "top", width: "150px" }}>Lokasi</td>
                      <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                      <td>{item.sales_branch?.branch_address[0]?.description}</td>
                    </tr>
                    <tr>
                      <td style={{ verticalAlign: "top", width: "150px" }}>Pengembang</td>
                      <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                      <td>{item.sales_company?.name ?? ""}</td>
                    </tr>
                  </tbody>
                </table>

                <p style={{ margin: "10px 0px" }}>Dengan ini Debitur menyatakan hal-hal sebagai berikut</p>

                <p style={{ margin: "20px 0px", fontWeight: "bold", fontSize: "16px", borderBottom: "1px solid #555" }}>
                  A. PERNYATAAN KONDISI BANGUNAN – PSU DAN KONDISI LEGALITAS SAAT AKAD KREDIT
                </p>

                <p style={{ margin: "20px 0px" }}>
                  Saya telah mengetahui, memahami, dan menerima kondisi bangunan, prasarana, sarana,
                  utilitas umum (PSU) serta legalitas/bukti kepemilikan atas unit rumah yang dibeli.
                  Saya mengetahui dan menerima bahwa kondisi berikut :
                </p>

                <table style={{ borderCollapse: "collapse", tableLayout: "fixed" }}>
                  <tbody>
                    <tr>
                      <td style={{ width: "50%", textAlign: "center", fontWeight: "bold", margin: "10px 0px", fontSize: "14px" }}>Kondisi Bangunan dan PSU Dalam Penyelesaian</td>
                      <td style={{ width: "50%", textAlign: "center", fontWeight: "bold", margin: "10px 0px", fontSize: "14px" }}>Legalitas</td>
                    </tr>
                    <tr>
                      <td style={{ width: "50%" }}>
                        <div style={{ margin: "5px 0px", display: "flex" }}><em style={{ flex: "0 0 20px", textAlign: "center", width: "20px", height: "20px", display: "inline-block", marginRight: "5px", marginBottom: "5px", border: "1px solid #000" }}><i className="ri-check-line fs-14"></i></em>KWH Listrik</div>
                        <div style={{ margin: "5px 0px", display: "flex" }}><em style={{ flex: "0 0 20px", textAlign: "center", width: "20px", height: "20px", display: "inline-block", marginRight: "5px", marginBottom: "5px", border: "1px solid #000" }}><i className="ri-check-line fs-14"></i></em>Bangunan Rumah</div>
                        <div style={{ margin: "5px 0px", display: "flex" }}><em style={{ flex: "0 0 20px", textAlign: "center", width: "20px", height: "20px", display: "inline-block", marginRight: "5px", marginBottom: "5px", border: "1px solid #000" }}><i className="ri-check-line fs-14"></i></em>Sumber Air Bersih</div>
                        <div style={{ margin: "5px 0px", display: "flex" }}><em style={{ flex: "0 0 20px", textAlign: "center", width: "20px", height: "20px", display: "inline-block", marginRight: "5px", marginBottom: "5px", border: "1px solid #000" }}><i className="ri-check-line fs-14"></i></em>Jalan Lingkungan</div>
                        <div style={{ margin: "5px 0px", display: "flex" }}><em style={{ flex: "0 0 20px", textAlign: "center", width: "20px", height: "20px", display: "inline-block", marginRight: "5px", marginBottom: "5px", border: "1px solid #000" }}><i className="ri-check-line fs-14"></i></em>Saluran Drainase</div>
                      </td>
                      <td style={{ width: "50%" }}>
                        <div style={{ margin: "5px 0px", display: "flex" }}><em style={{ flex: "0 0 20px", textAlign: "center", width: "20px", height: "20px", display: "inline-block", marginRight: "5px", marginBottom: "5px", border: "1px solid #000" }}><i className="ri-check-line fs-14"></i></em>Sertipikat berupa Peta Bidang Tanah/SKHGB/Sertipikat Induk/Sertipikat Pecahan</div>
                        <div style={{ margin: "5px 0px", display: "flex" }}><em style={{ flex: "0 0 20px", textAlign: "center", width: "20px", height: "20px", display: "inline-block", marginRight: "5px", marginBottom: "5px", border: "1px solid #000" }}><i className="ri-check-line fs-14"></i></em>Izin Mendirikan Bangunan (IMB) dalam Proses</div>
                        <div style={{ margin: "5px 0px", display: "flex" }}><em style={{ flex: "0 0 20px", textAlign: "center", width: "20px", height: "20px", display: "inline-block", marginRight: "5px", marginBottom: "5px", border: "1px solid #000" }}><i className="ri-check-line fs-14"></i></em>Persetujuan Bangunan Gedung (PBG) dalam proses</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p style={{ margin: "20px 0px" }}>*: dicoret yang tidak perlu.</p>
                <div style={{ margin: "5px 0px", display: "flex" }}><em style={{ flex: "0 0 20px", textAlign: "center", width: "20px", height: "20px", display: "inline-block", marginRight: "5px", marginBottom: "5px", border: "1px solid #000" }}><i className="ri-check-line fs-14"></i></em>
                  Saya mengerti dan menerima bahwa penyelesaian kewajiban bangunan – PSU dan legalitas rumah
                  adalah tanggung jawab dari penjual/pengembang.</div>
                <div style={{ margin: "5px 0px", display: "flex" }}><em style={{ flex: "0 0 20px", textAlign: "center", width: "20px", height: "20px", display: "inline-block", marginRight: "5px", marginBottom: "5px", border: "1px solid #000" }}><i className="ri-check-line fs-14"></i></em>
                  Debitur menyatakan telah memperoleh penjelasan yang memadai mengenal kondisi bangunan, PSU
                  dan legalitas rumah sebelum penandatanganan akad kredit.</div>

                <p style={{ margin: "20px 0px", fontWeight: "bold", fontSize: "16px", borderBottom: "1px solid #555" }}>
                  B. PERNYATAAN AKAD KREDIT KONDISI PERSETUJUAN BANGUNAN GEDUNG (PBG)
                </p>
                <div style={{ margin: "5px 0px", }}><em style={{ flex: "0 0 20px", textAlign: "center", width: "20px", height: "20px", display: "inline-block", marginRight: "5px", marginBottom: "5px", border: "1px solid #000" }}><i className="ri-check-line fs-14"></i></em>Debitur mengetahui dan menerima bahwa kondisi dokumen saat akad kredit adalah berupa
                  <b>Izin Mendirikan Bangunan (IMB) / Persetujuan Bangunan Gedung (PBG)*</b></div>


                <div style={{ breakAfter: "page" }}></div>
                <div style={{ marginTop: "40px" }}></div>

                <div style={{ margin: "5px 0px", display: "flex" }}><em style={{ flex: "0 0 20px", textAlign: "center", width: "20px", height: "20px", display: "inline-block", marginRight: "5px", marginBottom: "5px", border: "1px solid #000" }}><i className="ri-check-line fs-14"></i></em>Debitur mengetahui bahwa dokumen yang diterima Bank dari pihak Pengembang pada saat akad
                  Adalah dokumen Izin Mendirikan Bangunan (IMB) / Persetujuan Bangunan Gedung (PBG) sedang Dalam proses.</div>

                <div style={{ margin: "5px 0px", display: "flex" }}><em style={{ flex: "0 0 20px", textAlign: "center", width: "20px", height: "20px", display: "inline-block", marginRight: "5px", marginBottom: "5px", border: "1px solid #000" }}><i className="ri-check-line fs-14"></i></em>Debitur mengetahui bahwa dokumen bukti kepemilikan bangunan Gedung adalah Sertipikat Bukti
                  Kepemilikan Bangunan Gedung (SKHGB).</div>
                <div style={{ margin: "5px 0px", display: "flex" }}><em style={{ flex: "0 0 20px", textAlign: "center", width: "20px", height: "20px", display: "inline-block", marginRight: "5px", marginBottom: "5px", border: "1px solid #000" }}><i className="ri-check-line fs-14"></i></em> Dalam hal Pemerintah Kabupaten/Kota setempat memberlakukan ketentuan penerbitan Persetujuan
                  Bangunan Gedung (PBG), Sertipikat Laik Fungsi (SLF) dan Surat Bukti Kepemilikan Bangunan Gedung
                  (SKHBG), atau dikemudian hari terdapat perubahan ketentuan pemerintah maka pengurusan
                  Dokumen tersebut merupakan tanggung jawab dari pengembang.</div>
                <div style={{ margin: "5px 0px", display: "flex" }}><em style={{ flex: "0 0 20px", textAlign: "center", width: "20px", height: "20px", display: "inline-block", marginRight: "5px", marginBottom: "5px", border: "1px solid #000" }}><i className="ri-check-line fs-14"></i></em>Debitur memahami bahwa Bank bertindak sebagai pemberi fasilitas kredit dan tidak bertanggung
                  Jawab atas penerbitan, penyelesaian, maupun keterlambatan dokumen perizinan yang menjadi
                  Kewajiban pengembang.</div>

                <p style={{ margin: "20px 0px", fontWeight: "bold", fontSize: "16px", borderBottom: "1px solid #555" }}>
                  C. PERNYATAAN AGUNAN DAN PENGALIHAN HAK
                </p>
                <div style={{ margin: "5px 0px", display: "flex" }}><em style={{ flex: "0 0 20px", textAlign: "center", width: "20px", height: "20px", display: "inline-block", marginRight: "5px", marginBottom: "5px", border: "1px solid #000" }}><i className="ri-check-line fs-14"></i></em>Debitur menyatakan bahwa hak atas tanah dan/atau bangunan yang telah dilakukan balik nama ke atas
                  Nama debitur tetap menjadi jaminan/agunan KPR Bersubsidi BTN sampai seluruh kewajiban kredit
                  Dinyatakan lunas.</div>
                <div style={{ margin: "5px 0px", display: "flex" }}><em style={{ flex: "0 0 20px", textAlign: "center", width: "20px", height: "20px", display: "inline-block", marginRight: "5px", marginBottom: "5px", border: "1px solid #000" }}><i className="ri-check-line fs-14"></i></em>Selama masa kredit belum lunas, debitur bersedia dan setuju untuk tidak mengalihkan, menjual,
                  Menyewakan maupun memindahtangankan unit rumah kepada pihak lain tanpa persetujuan Bank BTN
                  Dan sesuai ketentuan perundang-undangan yang berlaku.</div>
                <p style={{ margin: "20px 0px", fontWeight: "bold", fontSize: "16px", borderBottom: "1px solid #555" }}>
                  D. LAIN-LAIN
                </p>
                <div style={{ margin: "5px 0px", display: "flex" }}><em style={{ flex: "0 0 20px", textAlign: "center", width: "20px", height: "20px", display: "inline-block", marginRight: "5px", marginBottom: "5px", border: "1px solid #000" }}><i className="ri-check-line fs-14"></i></em>Debitur mengerti bahwa BTN tidak memberikan penjaminan atas pemenuhan tanggung jawab
                  Pengembang.</div>
                <div style={{ margin: "5px 0px", display: "flex" }}><em style={{ flex: "0 0 20px", textAlign: "center", width: "20px", height: "20px", display: "inline-block", marginRight: "5px", marginBottom: "5px", border: "1px solid #000" }}><i className="ri-check-line fs-14"></i></em>Debitur menyatakan bahwa permasalahan dengan pengembang sehubungan dengan seluruh
                  Kondisi tersebut diatas tidak menghapus, menunda, atau mengurangi kewajiban pembayaran
                  Kepada Bank sesuai dengan perjanjian kredit.</div>
                <div style={{ margin: "5px 0px", display: "flex" }}><em style={{ flex: "0 0 20px", textAlign: "center", width: "20px", height: "20px", display: "inline-block", marginRight: "5px", marginBottom: "5px", border: "1px solid #000" }}><i className="ri-check-line fs-14"></i></em>Debitur memahami bahwa surat pernyataan ini merupakan satu kesatuan yang tidak terpisahkan
                  Dari perjanjian kredit dan seluruh dokumen fasilitas kredit yang ditandatangin oleh debitur
                  Dengan BTN.</div>
                <div style={{ margin: "5px 0px", display: "flex" }}><em style={{ flex: "0 0 20px", textAlign: "center", width: "20px", height: "20px", display: "inline-block", marginRight: "5px", marginBottom: "5px", border: "1px solid #000" }}><i className="ri-check-line fs-14"></i></em>Sepanjang BTN telah memenuhi kewajiban sesuai dengan perjanjian kredit, debitur melepaskan
                  BTN dari segala bentuk tuntutan hukum dikemudian hari yang timbul atas permasalahan dengan
                  Pengembang sehubungan dengan seluruh kondisi tersebut diatas.</div>


                <div
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    alignItems: "start",
                    gap: "10px",
                  }}
                >
                  <div
                    style={{
                      marginTop: "25px",
                      width: "250px",
                      textAlign: "center",
                    }}
                  >
                    <div>Bogor, ............................</div>
                    <div
                      style={{
                        marginTop: "100px",
                      }}
                    >{`${item.sales_customer?.name ?? ""}`}</div>
                  </div>
                </div>

                <div style={{ margin: "20px 0px", fontWeight: "bold" }}>Catatan:
                  <ol>
                    <li>Mohon centang pada kotak ceklis yang disediakan (      )</li>
                    <li>Pernyataan yang dipilih wajib sesuai kondisi kebijakan yang diperlukan</li>
                    <li>Dapat memilih dari 1 (satu) Checklist disesuaikan dengan kebijakan yang diperlukan</li>
                  </ol>
                </div>
              </div>

              <div style={{ breakAfter: "page" }}></div>
              <div style={{ padding: "60px 40px 40px 40px" }}>
                <div
                  style={{
                    textAlign: "center",
                    textDecoration: "underline",
                    fontSize: "18px",
                    fontWeight: "bold",
                  }}
                >
                  SURAT PERNYATAAN DEBITUR
                </div>
                <div style={{ padding: "20px" }}>
                  <table style={{ borderCollapse: "collapse", tableLayout: "fixed" }}>
                    <tbody>
                      <tr>
                        <td colSpan={3}>Yang bertanda tangan di bawah ini :</td>
                      </tr>
                      <tr>
                        <td style={{ verticalAlign: "top", width: "180px" }}>Nama</td>
                        <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                        <td>{item.sls_appl?.name ?? ""}</td>
                      </tr>
                      <tr>
                        <td style={{ verticalAlign: "top", width: "180px" }}>No. KTP</td>
                        <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                        <td>{item.sls_appl?.identity ?? ""}</td>
                      </tr>
                      <tr>
                        <td style={{ verticalAlign: "top", width: "180px" }}>Tempat/Tanggal Lahir</td>
                        <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                        <td>
                          {item.sls_appl?.birth_place ?? ""} , {handleValidDate(item.sls_appl?.birthat) ?? ""}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ verticalAlign: "top", width: "180px" }}>Pekerjaan</td>
                        <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                        <td>{item.sls_appl?.job_position ?? ""}</td>
                      </tr>
                      <tr>
                        <td style={{ verticalAlign: "top", width: "180px" }}>No. Telepon/HP</td>
                        <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                        <td>{item.sls_appl?.phone ?? ""}</td>
                      </tr>
                      <tr>
                        <td style={{ verticalAlign: "top", width: "180px" }}>Alamat</td>
                        <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                        <td>{item.sls_appl?.address ?? ""}</td>
                      </tr>
                    </tbody>
                  </table>

                  <p style={{ marginTop: "10px" }}>Selanjutnya, terhadap pembelian atas Tanah dan/atau Bangunan tersebut dibawah ini.</p>
                  <table style={{ borderCollapse: "collapse", tableLayout: "fixed", marginBottom: "20px" }}>
                    <tbody>
                      <tr>
                        <td style={{ verticalAlign: "top", width: "180px" }}>Perumahan</td>
                        <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                        <td>{item.sales_branch?.name ?? ""}</td>
                      </tr>
                      <tr>
                        <td style={{ verticalAlign: "top", width: "180px" }}>Blok Kavling No</td>
                        <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                        <td>{item.sales_detail[0]?.name ?? ""}</td>
                      </tr>
                      <tr>
                        <td style={{ verticalAlign: "top", width: "180px" }}>Alamat rumah yang dibeli</td>
                        <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                        <td>{item.sales_branch?.branch_address[0]?.description}</td>
                      </tr>
                    </tbody>
                  </table>
                  <p>Dengan ini menyatakan bahwa</p>
                  <ol style={{ marginLeft: "-15px", marginTop: "-10px" }}>
                    <li>
                      Menyatakan bahwa Hak atas tanah dan/atau bangunan yang telah balik atas nama
                      {item.sls_appl?.name ?? ""} masih menjadi jaminan/agunan atas kredit KPR Bersubsidi sesuai dengan Perjanjian Kredit antara Debitur dengan Pihak Bank BTN.
                    </li>
                    <li>Selama jangka waktu kredit atau utang belum dilunasi sesuai dengan Perjanjian Kredit KPR Bersubsidi dengan Pihak Bank BTN, Debitur bersedia dan setuju untuk tidak mengalihkan dan memperjualbelikan unit blok kavling yang telah akad di Bank BTN.</li>
                  </ol>
                  <p>Demikian Surat Pernyataan ini dibuat untuk dapat dipergunakan sebagaimana mestinya.</p>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "start",
                      gap: "10px",
                    }}
                  >
                    <div
                      style={{
                        marginTop: "25px",
                        width: "250px",
                        textAlign: "center",
                      }}
                    ></div>

                    <div
                      style={{
                        marginTop: "25px",
                        width: "250px",
                        textAlign: "center",
                      }}
                    >
                      <div>Bogor, {handleValidDate()}</div>
                      <div style={{ textAlign: "center" }}>PEMOHON</div>
                      <div
                        style={{
                          marginTop: "100px",
                        }}
                      >{`(${item.sls_appl?.name ?? ""})`}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ breakAfter: "page" }}></div>
              <div
                style={{
                  textAlign: "center",
                  textDecoration: "underline",
                  fontSize: "18px",
                  fontWeight: "bold",
                }}
              >
                SURAT KUASA
              </div>
              <div style={{ padding: "20px" }} className="page">
                <table style={{ borderCollapse: "collapse", tableLayout: "fixed" }}>
                  <tbody>
                    <tr>
                      <td colSpan={3}>Yang bertanda tangan di bawah ini :</td>
                    </tr>
                    <tr>
                      <td style={{ verticalAlign: "top", width: "150px" }}>Nama</td>
                      <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                      <td>{item?.sls_appl?.name ?? ""}</td>
                    </tr>
                    <tr>
                      <td style={{ verticalAlign: "top", width: "150px" }}>No. KTP</td>
                      <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                      <td>{item?.sls_appl?.identity ?? ""}</td>
                    </tr>
                    <tr>
                      <td style={{ verticalAlign: "top", width: "150px" }}>Tempat/Tanggal Lahir</td>
                      <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                      <td>
                        {item?.sls_appl?.birth_place ?? ""} , {handleValidDate(item?.sls_appl?.birthat) ?? ""}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ verticalAlign: "top", width: "150px" }}>Pekerjaan</td>
                      <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                      <td>{item?.sls_appl?.job_position ?? ""}</td>
                    </tr>
                    <tr>
                      <td style={{ verticalAlign: "top", width: "150px" }}>No. Telepon/HP</td>
                      <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                      <td>{item?.sls_appl?.phone ?? ""}</td>
                    </tr>
                    <tr>
                      <td style={{ verticalAlign: "top", width: "150px" }}>Alamat</td>
                      <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                      <td>{item?.sls_appl?.address ?? ""}</td>
                    </tr>
                  </tbody>
                </table>

                <p style={{ marginTop: "40px" }}>yang dalam hal ini bertindak untuk dan atas nama sendiri. Selanjutnya disebut “Pemberi Kuasa”. YAYAN SUTIATI,S.H.,M.Kn dalam hal ini bertindak dalam jabatan Notaris di Kabupaten Bogor yang Selanjutnya disebut “Penerima Kuasa”.</p>
                <p style={{ textAlign: "center" }}>KHUSUS</p>
                <p>dengan ini Pemberi Kuasa memberikan kuasa kepada Penerima Kuasa untuk dapat melakukan Pengambilan Sertifikat Elektronik atas nama Pemberi Kuasa di Kantor Pertanahan Kabupaten Bogor II</p>
                <p>yang selanjutnya Sertifikat tersebut akan diserahkan kepada PT Bank Tabungan Negara (Persero) Tbk atas dasar Perjanjian Kredit KPR Bersubsidi No&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;tanggal&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2024</p>
                <p>Demikian Surat Kuasa ini dibuat dengan Hak Substitusi, dan tidak dapat dicabut kembali serta tidak akan berakhir karena sebab – sebab yang tercantum dalam Pasal 1813 Kitab Undang – Undang Hukum Perdata atau karena sebab apapun juga.</p>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "start",
                    gap: "10px",
                  }}
                >
                  <div
                    style={{
                      marginTop: "25px",
                      width: "250px",
                      textAlign: "center",
                    }}
                  >
                    <div style={{ textAlign: "center" }}>PENERIMA KUASA</div>
                    <div
                      style={{
                        marginTop: "120px",
                      }}
                    >
                      (....................................................)
                    </div>
                    <div>Nama lengkap, Jabatan</div>
                    <div>*) coret yang tidak perlu</div>
                  </div>

                  <div
                    style={{
                      marginTop: "25px",
                      width: "250px",
                      textAlign: "center",
                    }}
                  >
                    <div>Bogor, {handleValidDate()}</div>
                    <div style={{ textAlign: "center" }}>PEMBERI KUASA</div>
                    <div
                      style={{
                        marginTop: "100px",
                      }}
                    >{`(${item.sls_appl?.name ?? ""})`}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );

    case "spd_pbg":
      return !item || item === undefined || item === null ? (
        <></>
      ) : (
        <div
          className="d-none"
          style={{
            overflow: "scroll",
            //backgroundColor: "blue"
          }}
        >
          <div ref={innerRef} className="bg-white" style={{ padding: "40px 40px 40px 40px" }}>
            <div
              style={{
                textAlign: "center",
                textDecoration: "underline",
                fontSize: "18px",
                fontWeight: "bold",
              }}
            >
              SURAT PERNYATAAN
            </div>
            <div style={{ padding: "20px" }}>
              <table style={{ borderCollapse: "collapse", tableLayout: "fixed" }}>
                <tbody>
                  <tr>
                    <td colSpan={3}>Yang bertanda tangan di bawah ini :</td>
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "top", width: "150px" }}>Nama</td>
                    <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                    <td>{item?.sales_customer?.name ?? ""}</td>
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "top", width: "150px" }}>Tempat, Tanggal Lahir</td>
                    <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                    <td>
                      {item?.sls_appl?.birth_place ?? ""} , {handleValidDate(item?.sls_appl?.birthat) ?? ""}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "top", width: "150px" }}>NIK</td>
                    <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                    <td>{item?.sls_appl?.identity ?? ""}</td>
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "top", width: "150px" }}>Alamat</td>
                    <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                    <td>{item?.sls_appl?.address ?? ""}</td>
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "top", width: "150px" }}>Blok</td>
                    <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                    <td>{`${item?.sales_detail[0]?.sales_detail_product?.product_block?.name ?? ""} - ${item?.sales_detail[0]?.sales_detail_product?.name ?? ""}`}</td>
                  </tr>
                </tbody>
              </table>

              <p style={{ marginTop: "40px" }}>Dalam Kapasitasnya Selaku : Debitur {item.sales_branch?.name}</p>
              <p>Dengan ini menyatakan hal-hal sebagai berikut: </p>
              <ol style={{ marginLeft: "-30px", listStyle: "none" }}>
                <li>
                  1. Mengetahui dan menerima bahwa kondisi dokumen saat akad kredit adalah berupa <span style={{ fontWeight: "bold" }}>Izin Mendirikan Bangunan (IMB) / Persetujuan Bangunan Gedung (PBG)</span>.
                </li>
                <li>2. Mengetahui bahwa dokumen yang diterima Bank dari pihak Pengembang pada saat akad adalah dokumen Persetujuan Bangunan Gedung (PBG) sedang dalam Proses.</li>
                <li>3. Mengetahui bahwa dokumen bukti kepemilikan bangunan gedung adalah Sertifikat Bukti Kepemilikan Bangunan Gedung (SBKBG).</li>
                <li>4. Dalam hal Pemerintah Kabupaten/Kota setempat memberlakukan ketentuan penerbitan Persetujuan Bangunan Gedung (PBG), Sertifikat Laik Fungsi (SLF) dan Surat Bukti Kepemilikan Bangunan Gedung (SBKBG), maka pengurusan dokumen tersebut merupakan tanggung jawab dari Pengembang.</li>
              </ol>
              <p>Surat Pernyataan ini saya buat dengan kesadaran tanpa adanya paksaan dari pihak manapun.</p>

              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  alignItems: "start",
                  gap: "10px",
                }}
              >
                <div
                  style={{
                    marginTop: "25px",
                    width: "250px",
                    textAlign: "center",
                  }}
                >
                  <div>Bogor, {handleValidDate()}</div>
                  <div>yang menyatakan</div>
                  <div
                    style={{
                      marginTop: "100px",
                    }}
                  >{`${item.sales_customer?.name ?? ""}`}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );

    case "spd_pbt":
      return !item || item === undefined || item === null ? (
        <></>
      ) : (
        <div
          className="d-none"
          style={{
            overflow: "scroll",
            //backgroundColor: "blue"
          }}
        >
          <div ref={innerRef} className="bg-white" style={{ padding: "40px 40px 40px 40px" }}>
            <div
              style={{
                textAlign: "center",
                textDecoration: "underline",
                fontSize: "18px",
                fontWeight: "bold",
              }}
            >
              SURAT PERNYATAAN
            </div>
            <div style={{ padding: "20px" }}>
              <table style={{ borderCollapse: "collapse", tableLayout: "fixed" }}>
                <tbody>
                  <tr>
                    <td colSpan={3}>Yang bertanda tangan di bawah ini :</td>
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "top", width: "150px" }}>Nama</td>
                    <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                    <td>{item.sales_customer?.name ?? ""}</td>
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "top", width: "150px" }}>Tempat, Tanggal Lahir</td>
                    <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                    <td>
                      {item.sls_appl?.birth_place ?? ""} , {handleValidDate(item.sls_appl?.birthat) ?? ""}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "top", width: "150px" }}>NIK</td>
                    <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                    <td>{item.sls_appl?.identity ?? ""}</td>
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "top", width: "150px" }}>Alamat</td>
                    <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                    <td>{item.sls_appl?.address ?? ""}</td>
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "top", width: "150px" }}>Pekerjaan</td>
                    <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                    <td>{item.sls_appl?.job_desc ?? ""}</td>
                  </tr>
                </tbody>
              </table>

              <p style={{ marginTop: "40px" }}>
                Dengan ini menyatakan telah mengetahui, memahami dan menerima kondisi atas pembelian unit rumah pada proyek perumahan {item.sales_branch?.name}, {item.sales_detail[0]?.name} yang dikembangkan oleh &nbsp;<span style={{ fontWeight: "bold" }}> {companyName}</span> dengan kondisi sebagai berikut:{" "}
              </p>
              <ol style={{ marginLeft: "-30px", listStyle: "none" }}>
                <li>1. Legalitas dalam proses penyelesaian/belum selesai saat ini masih berupa Peta bidang tanah dan masih dalam proses pengindukan.</li>
              </ol>
              <p>Sehubungan dengan hal di atas, kami menyatakan tidak akan mengaitkan penyelesaian kondisi di atas dengan pembayaran angsuran KPR Bersubsidi BTN.</p>
              <p>Demikian surat pernyataan ini dibuat dan di tanda tangani dengan sebenarnya, dan untuk dipergunakan sebagaimana mestinya.</p>
              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  alignItems: "start",
                  gap: "10px",
                }}
              >
                <div
                  style={{
                    marginTop: "25px",
                    width: "250px",
                    textAlign: "center",
                  }}
                >
                  <div>Yang menyetujui KPR</div>
                  <div>Bogor, {handleValidDate()}</div>
                  <div
                    style={{
                      marginTop: "100px",
                    }}
                  >{`${item.sls_appl?.name ?? ""}`}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );

    default:
      return <></>;
  }
};
